import { ApiConfig, Command, CommandHandler, ConsoleLogger, HttpService, L10nBase, TaggedUrl, Tags } from '@skylab-shared/core';
import { downloadFileDirectly, fillPlaceholders } from '@skylab-shared/utils';

export interface DocumentDownloadFileCommandParams {
    templateId: number;
    documentId: number;
    downloadDirectly?: boolean;
    config: {
        password?: string;
        compress?: boolean;
        duplicate?: boolean;
        dateOfDuplicate?: Date;
        ecoMode?: boolean;
    };
}

export type DocumentDownloadFileCommandResult = void;

export class DocumentDownloadFileCommand extends Command<DocumentDownloadFileCommandParams, DocumentDownloadFileCommandResult> { }

export class DocumentDownloadFileCommandHandlerBase implements CommandHandler<DocumentDownloadFileCommand, DocumentDownloadFileCommandParams, DocumentDownloadFileCommandResult> {
    private static Url = TaggedUrl.join('documents/:documentId/printing?templateId=:templateId', [Tags.Api]);
    private logger: ConsoleLogger;

    public constructor(
        private readonly http: HttpService,
        private readonly l10n: L10nBase
    ) {
        this.logger = new ConsoleLogger(this.constructor.name);
    }

    public async handleAsync({ params }: DocumentDownloadFileCommand): Promise<DocumentDownloadFileCommandResult> {
        const inNewWindow = !(params?.config?.compress || params?.downloadDirectly);
        let newWindow!: Window;

        try {
            //prepare new window - placeholder for file
            if (inNewWindow) {
                newWindow = window.open('about:blank', '_blank')!;
                newWindow.document.write(this.l10n.instant('business.document.common.download-file.waiting-message'));
            }

            // get file url
            const { data } = await this.http.post(fillPlaceholders(DocumentDownloadFileCommandHandlerBase.Url, { documentId: params?.documentId, templateId: params?.templateId }), { ...params?.config });

            const targetUrl = `${ApiConfig.baseUrl}${data.url}`;
            // show or download file
            if (inNewWindow) {
                newWindow.location.href = targetUrl;
            } else {
                downloadFileDirectly(targetUrl);
            }
        } catch (err) {
            newWindow?.close();
            this.logger.error(err);
            throw err;
        }
    }
}
